import {NavLink} from "react-router-dom";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


export const news = (context) => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: {max: 8000, min: 3000},
            items: 4
        },
        desktop: {
            breakpoint: {max: 3000, min: 1024},
            items: 4
        },
        tablet: {
            breakpoint: {max: 1024, min: 650},
            items: 2
        },
        mobile: {
            breakpoint: {max: 650, min: 0},
            items: 1
        }
    };
    return (
        <div className='cMarginTop1 cBorder7 row cBg12 p-5 position-relative cPx1 justify-content-center'>

            <div className='cContainer col-12'>
                <div className='row'>
                    <div className='col-12 mb-4'>
                        <h2 className="d-inline-block cFontSize20 cFontSize16_768 fw-bold">اخبار</h2>
                        <NavLink to={urlDynamic.path.newsAllFa}
                                 className='d-inline-block cColor5 float-end cZindexLink'> مشاهده
                            همه
                              <svg stroke="currentColor" fill="currentColor"
                                                                             strokeWidth="0" viewBox="0 0 16 16"
                                                                             className="text-main-color ms-1"
                                                                             height="1em"
                                                                             width="1em"
                                                                             xmlns="http://www.w3.org/2000/svg"><path
                                                                            fillRule="evenodd"
                                                                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path></svg>
                        </NavLink>
                    </div>
                    <div className='col-12 px-1'>
                        <Carousel
                            showDots={false}
                            className='cCarous1'
                            infinite={false}
                            draggable={true}
                            arrows={true}
                            rtl={true}
                            autoPlay={false}
                            autoPlaySpeed={3000}
                            itemClass="px-2"
                            responsive={responsive}>
                            {context.state.sHome.akhbar.map((p, index) => (
                                <div>
                                        <NavLink to={p.url} key={index}
                                                 className="cHover7 card position-relative overflow-hidden rounded-0 h-100 rounded rounded-4">
                                            <img src={p.urlImage} width="960" height='720' className="img-fluid w-100"
                                                 alt="تصویر"/>
                                        </NavLink>
                                    <NavLink to={p.url}
                                             className='text-dark fw-bold d-block text-center mt-2 lh-lg cFontSize12 cTransition'>
                                        {p.title}
                                    </NavLink>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    )
}
